import React from 'react'
import { personaHomeList } from '../../../data/data'
import HomePersonaSectionItem from './HomePersonaSectionItem'
export default function HomePersonaSection() {
  return (
    <div className='flex justify-around lg:flex-row flex-col '>
      {
        personaHomeList &&
        personaHomeList.map((item, i) => (
          // showRightLine if element is last show last right line 
          <HomePersonaSectionItem key={item.id} data={item} showRightLine={personaHomeList.length === i + 1} />
        ))
      }
    </div>
  )
}
